module.exports = "<div>\n  <main>\n    <router-outlet></router-outlet>\n  </main>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/sample-app.tmpl.html
 ** module id = 723
 ** module chunks = 1
 **/